/* eslint-disable @typescript-eslint/explicit-function-return-type */
// eslint-disable-next-line @typescript-eslint/ban-types
export function matchingClassDecorator<T extends { new (...args: any[]): {} }>(
    constructor: T
) {
    return class extends constructor {
        showSelectedSteps = false;

        Threeshold = 0;

        showStep = false;
    };
}
